module.exports = __webpack_public_path__ + "static/media/off.65de69f5.svg";